import {
  PERSONALIZED_COURSE_COOKIE_NAME,
  resolvePersonalizedCourse,
} from '@lib/utils/personalized-course'
import { useRouter } from 'next/router'
import { setCookie } from 'nookies'
import { useEffect } from 'react'

// Remembers `?course=` for 30 days so funnel pages that lose the param
// (logins, redirects, new tabs) can recover it. `coding` is stored too, so the
// latest explicit choice always replaces an older specialized course.
const usePersistPersonalizedCourse = (): void => {
  const router = useRouter()
  const courseQuery = router.query.course

  useEffect(() => {
    if (!router.isReady) return

    const resolvedSlug = resolvePersonalizedCourse(courseQuery)
    if (!resolvedSlug) return

    setCookie(null, PERSONALIZED_COURSE_COOKIE_NAME, resolvedSlug, {
      path: '/',
      maxAge: 60 * 60 * 24 * 30,
    })
  }, [router.isReady, courseQuery])
}

export default usePersistPersonalizedCourse
